// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"e71a9ca9","162":"ce1477e2","184":"cc98bc36","294":"f4486450","496":"58b940c3","625":"8084a5ab","693":"f82d4f1e","716":"1144ad7c","787":"2de1dad5"}[chunkId] + ".chunk.js";
};